import { smsApi } from "api/instances";
import { GlobalApplicationState } from "globalApplicationState";
import PublishedContentDialog from "modules/common/components/authoring/dialogs/publishedContentDialog";
import { useRetryableRequest } from "modules/common/hooks/useRetryableRequest";
import { ContentType } from "modules/common/models";
import React from "react";
import { useSelector } from "react-redux";
import { ISMS } from "./models";

interface ISentSMSDialogProps {}

const MAX_RETRY_COUNT = 3;

const SentSMSDialog: React.FC<ISentSMSDialogProps> = ({}) => {
    const { smsId, expectedSentTime } = useSelector((state: GlobalApplicationState) => state.sms.sentConfirmation);
    const fetchSMS = async () => await smsApi.getSMS(smsId);

    const { response, isFailed } = useRetryableRequest<ISMS>({
        asyncRequest: fetchSMS,
        maxRetry: MAX_RETRY_COUNT,
        requesting: !!smsId
    });

    return <PublishedContentDialog
        content={ContentType.SMS}
        expectedPublishTime={expectedSentTime}
        contentId={response?.id}
        hideFeedRedirect={isFailed}
    />;
};

export default SentSMSDialog;
